import DataSetType from '../audience/DataSetType';

export default class InputDatasetEmptyError extends Error {
  constructor(type: DataSetType) {
    super(`Dataset ${type} is empty.`);
  }
}
